import React, {useContext} from "react";
import {Grid, ToggleButton, ToggleButtonGroup} from "@mui/material";
import {LanguageContext} from "../../context/LanguageContext";
import {makeStyles} from "@mui/styles";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";
import {contactHasRight} from "../../utils/commonFunctions";
import {CustomerContext} from "../../context/CustomerContext";

const useStyles = makeStyles(() => ({
  buttonStyle: {
    height: "130px",
    maxHeight: "165px"
  }
}));

const buttonData = {
  service: {text: "serviceAdministration", icon: "tune_outlined", access: ['ADMIN']},
  bill: {text: "invoicingAdministration", icon: "payments_outlined"},
  requestForOffer: {text: "requestForOffer", icon: "local_mall_outlined", access: ['ADMIN']}
};

const AdministrationButtons = ({value, handleChange, disabled}) => {
  const classes = useStyles();
  const languageContext = useContext(LanguageContext);
  const customerContext = useContext(CustomerContext);

  return (
      <ToggleButtonGroup
        fullWidth
        disabled={disabled}
        value={value}
        exclusive
        onChange={handleChange}
        style={{display: 'flex', justifyContent: 'center'}}
      >
        {Object.entries(buttonData).map(([key], index) => (
          contactHasRight(customerContext?.selectedContact?.roles, buttonData[key].access) ? (
            <ToggleButton key={`ToggleButton${index}`} value={key} color="secondary" className={classes.buttonStyle}>
              <Grid container item xs={12}>
                <Grid item xs={12}>
                  <Icon>{buttonData[key].icon}</Icon>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" fontSize={13}>{languageContext.dictionary[buttonData[key].text]}</Typography>
                </Grid>
              </Grid>
            </ToggleButton>
          ) : null
        ))}
      </ToggleButtonGroup>
  );
};

AdministrationButtons.propTypes = {
  handleChange: PropTypes.func,
  value: PropTypes.string,
  disabled: PropTypes.bool
};
export default AdministrationButtons;